import React from 'react';

export default function InfoIcon() {
  return (
    <span>
      <svg width="30px" height="24px" viewBox="0 0 25 20" version="1.1">
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity="1">
          <g id="info" transform="translate(-2.000000, -1.000000)">
            <g id="info-button" transform="translate(2.000000, 1.000000)">
              <path
                d="M13.303431,2.69645086 L13.3035098,2.69652959 C10.37447,-0.232184083 5.62563083,-0.232284926 2.69650991,2.69650991 C-0.232284926,5.62530475 -0.232184082,10.3741439 2.69647054,13.3034507 C5.62551484,16.2318428 10.3743844,16.2319437 13.3034507,13.3035295 C16.2319469,10.3743811 16.2318461,5.62584423 13.303431,2.69645086 Z"
                id="Path"
                stroke="#424750"></path>
              <path
                d="M9.04313043,11.4782609 C9.04313043,12.0546087 8.576,12.5217391 7.99965217,12.5217391 C7.42330435,12.5217391 6.95617391,12.0546087 6.95617391,11.4782609 L6.95617391,7.30434783 C6.95617391,6.728 7.42330435,6.26086957 7.99965217,6.26086957 C8.576,6.26086957 9.04313043,6.728 9.04313043,7.30434783 L9.04313043,11.4782609 Z M7.98121739,5.60556522 C7.38017391,5.60556522 6.97947826,5.16095933 6.992,4.61210354 C6.97947826,4.03673122 7.38017391,3.60556522 7.9933913,3.60556522 C8.60695652,3.60556522 8.99513043,4.03709446 9.008,4.61210354 C9.00765217,5.16095933 8.60730435,5.60556522 7.98121739,5.60556522 Z"
                id="Combined-Shape"
                fill="#424750"></path>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}
